<script>
//! sqlRow使用JSX进行编写
//! 请知悉 Render/JSX-VUE/函数组件/React思路/计算属性/v-model实现原理
import { globalValue, operators, FSelect, TypeMap } from "./utils";
const fieldKey = TypeMap.field.id;
const subFieldKey = TypeMap.subField.id;
const field_enum = { 2: fieldKey, 3: subFieldKey, [fieldKey]: 2, [subFieldKey]: 3 };

/**
 * @description sql行组件
 * */
export default {
  props: {
    expr: { default: () => ({}), type: Object }
  },
  computed: {
    // 上级组件,就是 layout.vue实例
    sqlRoot() {
      return this.$vnode.context;
    },
    subTableId() {
      return this.$vnode.subTableId;
    },
    // 当前字段下拉列表
    formFields() {
      return this.sqlRoot.formFields;
    },
    // 当前值字段下拉列表(表单字段,全局字段)
    valueFields() {
      const {
        sqlRoot: { tableFields, subFields },
        expr: { valueSource }
      } = this;
      const list = valueSource === 3 ? subFields : tableFields;
      return list.concat(globalValue);
    },
    // 当前选中运算符对象
    curOpr() {
      return operators.find(({ id }) => id === this.expr.op) || {};
    },
    // 是否显示值(一些运算符不需要值)
    showValue() {
      return this.typeList.length;
    },
    // 值的类型下拉列表
    typeList() {
      const {
        sqlRoot: { subTableId },
        curOpr: { valueType }
      } = this;
      const list = valueType || [];
      return subTableId ? list : list.filter(({ id }) => id !== subFieldKey);
    },
    // 当前类型对象
    curValueType() {
      const {
        expr: { valueType }
      } = this;
      return this.typeList.find(({ id }) => id === valueType) || {};
    }
  },
  methods: {
    clearValue() {
      const { expr } = this;
      expr.value = "";
      expr.value2 = "";
    },
    onOpChange() {
      const valueType = this.curOpr.valueType[0]?.id;
      this.onTypeChange(valueType);
    },
    // 特殊规则: 当选择 值下拉列表选择'字段'时 valueSource改为2,否则为1
    // 同时 valueType 根本就没有字段类型,应该清理为空,否则接口会出问题
    onTypeChange(value) {
      const { expr } = this;
      if (field_enum[value]) {
        expr.valueSource = field_enum[value];
        expr.valueType = "";
      } else {
        expr.valueSource = 1;
        expr.valueType = value;
      }
      this.clearValue();
    }
  },
  render() {
    const {
      expr,
      valueFields,
      curOpr: { value2 }
    } = this;
    // 值组件,左侧类型下拉,右侧输入框
    const CheckInput = () => {
      const {
        curValueType: { input: TypeInput }
      } = this;
      const isStatic = expr.valueSource === 1;
      const formatType = isStatic ? expr.valueType : field_enum[expr.valueSource];
      // 默认显示一个输入框,根据条件判断是否添加第二个
      // 输入框绑定字段名列表
      const valueList = ["value"];
      if (value2) valueList.push("value2");
      // 将值字段列表转换为输入
      const inputList = valueList.map((key, index) => {
        return isStatic ? (
          TypeInput ? (
            // 使用对应类型的输入组件
            <TypeInput key={`static-${index}`} vModel={expr[key]} />
          ) : undefined
        ) : (
          // 选中'字段'使用 表单字段下拉
          <FSelect key={`field-${index}`} vModel={expr[key]} list={valueFields} />
        );
      });
      //  左侧
      return (
        <div class='input-group'>
          <div class='prefix ghost'>
            <FSelect value={formatType} list={this.typeList} onInput={this.onTypeChange} />
          </div>
          <div class='input-content'>{inputList}</div>
        </div>
      );
    };
    // 根据条件是否显示值组件
    const ValueTd = () => (this.showValue ? <CheckInput /> : undefined);
    // 两个插槽
    const { prefix, suffix } = this.$slots;
    return (
      <tr class='sql-tr'>
        {prefix ? <td>{prefix}</td> : undefined}
        <td>
          <FSelect vModel={expr.fieldName} list={this.formFields} />
        </td>
        <td>
          <FSelect vModel={expr.op} list={operators} onChange={this.onOpChange} />
        </td>
        <td>
          <ValueTd />
        </td>
        {suffix ? <td>{suffix}</td> : undefined}
      </tr>
    );
  }
};
</script>
<style lang="scss" scoped src="./row.scss"></style>
